import React, { useState, useEffect } from "react";
import { useContextStateManagement } from "../../context/ContextApi";
import { login, logout } from "../../features/userSlice";
import { useDispatch } from "react-redux";
import { isNumber } from "../../Variables";
import { useNavigate } from "react-router-dom";
import "./Auth.css";

export default function VerifyMFA({
  outBoundLeadsDetail,
  setOutBoundLeadsDetail,
  setCurrentRoute,
  setUserDataAccess,
  userDataAccess,
  setDeviceName,
  registeredUserEmail,
  registerdUserToken,
  setRegisterdUserToken,
  setRegisteredUserEmail,
}) {
  const [mfaToken, setMfaToken] = useState("");
  const [mfaTokenMessage, setMfaTokenMessage] = useState("");
  const [isTokenExpired, setIsTokenExpired] = useState(false);
  const { usersPostRequest, setToken, setUserType } =
    useContextStateManagement();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const resetErrorMessage = () => setMfaTokenMessage("");

  const handleVerify = async () => {
    if (mfaToken === "") {
      setMfaTokenMessage("Enter the code");
      return;
    }

    const url = "/api/verifyQRCode";
    const verificationCode = mfaToken;
    const obj = { registeredUserEmail, verificationCode };
    const userData = await usersPostRequest(registerdUserToken, url, obj);

    if (userData == "Token is expired, login again") {
      setIsTokenExpired(true);
    } else if (userData && userData.message === "success") {
      dispatch(login({ ...userDataAccess, token: userData.token }));
      setDeviceName("");
      setRegisterdUserToken("");
      setRegisteredUserEmail("");
      setMfaTokenMessage("");
      setCurrentRoute("");
      const redirectTo = sessionStorage.getItem("postLoginRedirect");
      sessionStorage.removeItem("postLoginRedirect");
      navigate(redirectTo || "/", { replace: true });
    } else if (userData && userData === "Invalid token") {
      setMfaTokenMessage("Invalid code. Please try again.");
    }
  };

  const handleKeyDown = (event) => {
    if (event.keyCode === 13 || event.which === 13) {
      handleVerify();
    }
  };

  const handleProviderContact = (event) => {
    if (isNumber.test(event.target.value)) {
      setMfaToken(event.target.value);
    }
  };

  useEffect(() => {
    if (isTokenExpired === true) {
      setToken("");
      setUserType("client");
      setIsTokenExpired(false);
      dispatch(logout());
    }
  }, [dispatch, isTokenExpired, setToken, setUserType]);

  return (
    <div className="row login-start login-page-shell">
      <div className="col-12">
        <div className="login-layout login-layout--centered">
          <section className="login-form-panel login-form-panel--centered auth-flip-card glass-panel setting-login">
            <div className="login-form-header">
              <p className="login-form-eyebrow">Multi-factor Authentication</p>
              <p className="login-form-subtitle">
                Enter an MFA code to complete sign-in.
              </p>
            </div>

            <div className="form-group form-hidden mb-2 py-1 position-relative">
              <label className="login-field-label" htmlFor="deviceName">
                MFA Code
              </label>
              <div className="col-sm-12">
                <input
                  type="text"
                  id="deviceName"
                  onFocus={resetErrorMessage}
                  value={mfaToken}
                  onChange={handleProviderContact}
                  onKeyDown={handleKeyDown}
                  maxLength={6}
                  placeholder="000000"
                  className="login-field-input codeVerificationInput form-control text-center"
                />
              </div>
              {mfaTokenMessage && (
                <small className="pb-2 text-danger position-absolute fs-small login-field-error">
                  {mfaTokenMessage}
                </small>
              )}
            </div>

            <div className="login-action-stack">
              <button
                disabled={mfaToken.length !== 6}
                onClick={handleVerify}
                type="submit"
                className="simple-btn login-btn form-hidden login-submit-btn"
              >
                Next
              </button>
            </div>
          </section>
        </div>
      </div>
    </div>
  );
}
